import React, { Component } from "react";
import EntryForm1 from "../../components/EntryForms/EntryForm1/EntryForm1";
import axiosInstance from "../../api/utils/axiosInstance";
import { connect } from "react-redux";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import {
  handleUserInput,
  handleMappedUserInput,
} from "../../helperFunctions/EntryFormHelperFunctions/userInputHandlers";
import {
  handleCountryAutocomplete,
  countryAutocompleteHandler,
  countyAutocompleteHandler,
  cityAndMuncipalityAutocomplete,
  districtAutocompleteHandler,
} from "../../helperFunctions/EntryFormHelperFunctions/autocompleteHelpers";
import { handleDayPicker } from "../../helperFunctions/EntryFormHelperFunctions/datePickerHelper";
import {
  validateRequiredFields,
  validateArrayFields,
} from "../../helperFunctions/validationHelpers/validateRequiredFields";
import Spinner from "../../components/UI/Spinner/Spinner";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import { purgeUpdateAndRedirect } from "../../helperFunctions/purgeUpdateAndRedirect";
import { PURGE_UPDATE } from "../../constants/constants";

class RegistarRevizorskihDrustava extends Component {
  state = {
    countryList: [],
    countyList: [],
    showUpdateModal: false,
    cityAndMuncipalityList: [],
    districtList: [],
    legalForms: [],
    selectedLegalForm: [],
    networksList: [],
    update: false,
    error: false,
    loader: false,
    requestsLoaded: false,
    newFormData: {
      oznDokumenta: {
        oznDokumenta: "",
      },
      userData: {
        vrDrustva: "1",
        oib: "",
        nazDrustva: "",
        regBroj: "",
        sifPOblika: "",
        opisPOblika: "",
        oibValidated: false,
        oznAkt: "",
        requiredFieldsUserData: ["oib", "nazDrustva", "sifPOblika"],
        tstampUnosa: null,
      },
      address: {
        vrAdr: "1",
        sifDrzave: "191",
        sifZupanije: "",
        nazZupanije: "",
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        permitDate: "",
        permitNumber: "",
        requiredFieldsAddress: [
          "sifDrzave",
          "sifZupanije",
          "nazZupanije",
          "sifGrdOpc",
          "nazGrdOpc",
          "sifNaselja",
          "nazNaselja",
          // "brPoste",
          "ulicaKbr",
          "permitDate",
          "permitNumber",
        ],
      },
      contactInformation: [
        {
          ime: "",
          prezime: "",
          telefon: "",
          web: "",
          email: "",
          emailValidated: false,
          id: 1,
        },
      ],

      officeAddress: [
        {
          vrAdr: "2",
          ulicaKbr: "",
          nazNaselja: "",
          brPoste: "",
          sifDrzave: "191",
          id: 1,
        },
      ],
      basicReviserData: [
        {
          oib: "",
          prezime: "",
          ime: "",
          regBroj: "",
          idOsobe: "",
          id: 1,
          requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: false,
        },
      ],
      auditCompanyMember: [
        {
          vrClana: "1",
          oib: "",
          ime: "",
          prezime: "",
          naziv: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: 1,
          oibValidated: false,
          requiredFieldsAuditCompanyMember: [
            "oib",
            // "ime",
            // "naziv",
            // "prezime",
            "sifDrzave",
            // "nazNaselja",
            // "brPoste",
            // "ulicaKbr"
          ],
        },
      ],
      auditCompanyBoardMember: [
        {
          vrClana: "2",
          oib: "",
          ime: "",
          prezime: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: 1,
          funkcija: "",
          oibValidated: false,
          requiredFieldsAuditCompanyBoardMember: [
            "ime",
            "prezime",
            "sifDrzave",
            // "nazNaselja",
            // "brPoste",
            // "ulicaKbr",
            "funkcija",
          ],
        },
      ],
      auditCompanyRegistration: [
        {
          vrRegistracije: "2",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          id: 1,
        },
      ],
      auditCompanyRegistrationForeign: [
        {
          vrRegistracije: "3",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          id: 1,
        },
      ],

      supervisoryAuthority: [
        {
          vrRegistracije: "4",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: 1,
        },
      ],
      createNewNetworkModal: false,
      createNewNetworkData: {
        nazMreze: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        requiredFieldsCreateNewNetwork: [
          "nazMreze",
          "sifDrzave",
          "nazNaselja",
          "brPoste",
          "ulicaKbr",
        ],
      },
      memberInfo: [
        {
          vrClana: "",
          // memberType: "",
          id: 1,
          idMreze: "",
          nazDrustva: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
          // requiredFieldsMemberInfo: ["vrClana"]
        },
      ],
      dropDownData: [
        { id: 3, value: "Direktor"},
        { id: 4, value: "Predsjednik uprave" },
        { id: 5, value: "Član uprave" },
        { id: 6, value: "Prokurist" },
        { id: 7, value: "Član upravnog odbora" },
      ],
    },
    networkMemberInfo: {
      isDrustvoMreza: false,
      idMreze: "",
    },
    mjere: [],
  };

  componentDidMount = async () => {
    this.getCountryList();
  };

  getDrustvoEdit = async (oznaka) => {
    const {
      idDrustva,
      vrDrustva,
      // match: { params },
    } = this.props;

    const { data } = await axiosInstance.get(
      `/findDrustvo?idDrustva=${idDrustva}&vrDrustva=${vrDrustva}&showHistory=false`
    );

    //adrese
    const addressRegistration = data[3].find(
      (element) => element.vrRegistracije == 1
    );

    const findAddress = data[2].find((element) => element.vrAdr == 1);
    
    const address = {
      vrAdr: "1",
      sifDrzave: findAddress.sifDrzave ? String(findAddress.sifDrzave) : "",
      sifZupanije: findAddress.sifZupanije ?  String(findAddress.sifZupanije) : "",
      nazZupanije: findAddress.nazZupanije || "",
      sifGrdOpc:findAddress.sifGrdOpc ? String(findAddress.sifGrdOpc) : "",
      nazGrdOpc: findAddress.nazGrdOpc || "",
      sifNaselja: findAddress.sifNaselja ? String(findAddress.sifNaselja) : "",
      nazNaselja: findAddress.nazNaselja || "",
      brPoste: findAddress.brPoste || "",
      ulicaKbr: findAddress.ulicaKbr || "",
      permitDate: addressRegistration.datReg || "",
      permitNumber: addressRegistration.brReg || "",
      requiredFieldsAddress: [
        "sifDrzave",
        "sifZupanije",
        "nazZupanije",
        "sifGrdOpc",
        "nazGrdOpc",
        "sifNaselja",
        "nazNaselja",
        // "brPoste",
        "ulicaKbr",
        "permitDate",
        "permitNumber",
      ],
    };

    if (address.sifZupanije) {
      this.getCityAndMuncipalityList(address.sifZupanije);
    }

    if (address.sifGrdOpc) {
      this.getDistrictList(address.sifGrdOpc);
    }

    const officeAddress = data[2]
      .filter((element) => element.vrAdr == 2)
      .map((element, index) => {
        return {
          vrAdr: "2",
          ulicaKbr: element.ulicaKbr || "",
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          sifDrzave: String(element.sifDrzave) || "",
          id: index + 1,
        };
      });

    //registracije
    const findAuditCompanyRegistration = data[3].filter(
      (element) => element.vrRegistracije === 2
    );

    let auditCompanyRegistration;
    if (findAuditCompanyRegistration.length > 0) {
      auditCompanyRegistration = findAuditCompanyRegistration.map(
        (element, index) => {
          return {
            vrRegistracije: "2",
            nazTijela: element.nazTijela || "",
            sifDrzave: String(element.sifDrzave),
            nazNaselja: element.nazNaselja || "",
            brPoste: element.brPoste || "",
            ulicaKbr: element.ulicaKbr || "",
            brReg: element.brReg || "",
            datReg: element.datReg || "",
            id: index + 1,
          };
        }
      );
    } else {
      auditCompanyRegistration =
        this.state.newFormData.auditCompanyRegistration;
    }

    const findAuditCompanyRegistrationForeign = data[3].filter(
      (element) => element.vrRegistracije === 3
    );

    let auditCompanyRegistrationForeign;
    if (findAuditCompanyRegistrationForeign.length > 0) {
      auditCompanyRegistrationForeign = findAuditCompanyRegistrationForeign.map(
        (element, index) => {
          return {
            vrRegistracije: "2",
            nazTijela: element.nazTijela || "",
            sifDrzave: String(element.sifDrzave),
            nazNaselja: element.nazNaselja || "",
            brPoste: element.brPoste || "",
            ulicaKbr: element.ulicaKbr || "",
            brReg: element.brReg || "",
            datReg: element.datReg || "",
            id: index + 1,
          };
        }
      );
    } else {
      auditCompanyRegistrationForeign =
        this.state.newFormData.auditCompanyRegistrationForeign;
    }

    const findSupervisoryAuthority = data[3].filter(
      (element) => element.vrRegistracije == 4
    );

    let supervisoryAuthority;
    if (findSupervisoryAuthority.length > 0) {
      supervisoryAuthority = findSupervisoryAuthority.map((element, index) => {
        return {
          vrRegistracije: "4",
          nazTijela: element.nazTijela || "",
          sifDrzave: String(element.sifDrzave),
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr || "",
          id: index + 1,
        };
      });
    } else {
      supervisoryAuthority = this.state.newFormData.supervisoryAuthority;
    }

    // osoba/osobe za kontakt
    const contactInformation = data[4].map((element, index) => {
      return {
        ime: element.ime || "",
        prezime: element.prezime || "",
        telefon: element.telefon || "",
        web: element.web || "",
        email: element.email || "",
        emailValidated: true,
        id: index + 1,
      };
    });

    let hasAuditCompanyMember = (data[6].length > 0) && data[6].filter(element => element.vrClana == 1).length > 0;
    const auditCompanyMember = hasAuditCompanyMember ?
        data[6].filter((element) => element.vrClana == 1)
            .map((element, index) => {
              return {
                vrClana: "1",
                oib: element.oib || "",
                ime: element.ime || "",
                prezime: element.prezime || "",
                naziv: element.naziv || "",
                sifDrzave: String(element.sifDrzave) || "",
                nazNaselja: element.nazNaselja || "",
                brPoste: element.brPoste || "",
                ulicaKbr: element.ulicaKbr || "",
                id: index + 1,
                oibValidated: true,
                requiredFieldsAuditCompanyMember: [
                  "oib",
                  // "ime",
                  // "prezime",
                  // "naziv",
                  "sifDrzave",
                  // "nazNaselja",
                  // "brPoste",
                  // "ulicaKbr"
                ],
              };
            })
        :
        this.state.newFormData.auditCompanyMember;

    let hasAuditCompanyBoardMember = (data[6].length > 0) && data[6].filter(element => element.vrClana == 2).length > 0;
    const auditCompanyBoardMember = hasAuditCompanyBoardMember ?
        data[6].filter((element) => element.vrClana == 2)
            .map((element, index) => {
              return {
                vrClana: "2",
                oib: element?.oib || "",
                ime: element?.ime || "",
                prezime: element?.prezime || "",
                sifDrzave: String(element.sifDrzave) || "",
                nazNaselja: element?.nazNaselja || "",
                brPoste: element?.brPoste || "",
                funkcija: element?.funkcija || "",
                ulicaKbr: element?.ulicaKbr || "",
                id: index + 1,
                oibValidated: true,
                requiredFieldsAuditCompanyBoardMember: [
                  "ime",
                  "prezime",
                  "funkcija",
                  "sifDrzave",
                  // "nazNaselja",
                  // "brPoste",
                  // "ulicaKbr"
                ],
              };
            })
        : this.state.newFormData.auditCompanyBoardMember;

    let basicReviserData;

    if (data[5].length > 0) {
      basicReviserData = data[5].map((element, index) => {
        return {
          oib: element?.oibIdBrojOsobe || "",
          prezime: element?.prezimeOsobe || "",
          ime: element?.imeOsobe || "",
          idOsobe: element?.idOsobe || "",
          id: index + 1,
          requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          regBroj: element?.regBrojOsobe || "",
        };
      });
    } else {
      basicReviserData = this.state.newFormData.basicReviserData;
    }

    let networkMemberInfo;
    const isDrustvoMreza = data[7].isDrustvoMreza;
    if (!isDrustvoMreza) {
      networkMemberInfo = {
        isDrustvoMreza: "0",
        idMreze: "",
      };
    } else {
      networkMemberInfo = {
        isDrustvoMreza: "1",
        idMreze: data[7].idMreze,
      };
    }

    let memberInfo;

    if (data[8].length > 0) {
      memberInfo = data[8].map((element, index) => {
        return {
          vrClana: String(element.vrClana),
          // memberType: "",
          id: index + 1,
          idMreze: element?.idMreze,
          nazDrustva: element?.nazDrustva,
          sifDrzave: String(element?.sifDrzave) || "",
          nazNaselja: element?.nazNaselja || "",
          brPoste: element?.brPoste || "",
          ulicaKbr: element?.ulicaKbr || "",
          web: element?.web || "",
        };
      });
    } else {
      memberInfo = this.state.newFormData.memberInfo;
    }

    let oznDokumenta = {};

    if (oznaka) {
      oznDokumenta.oznDokumenta = oznaka;
    } else {
      oznDokumenta.oznDokumenta = data[9].oznDokumenta;
    }

    this.setState((prevState) => ({
      ...prevState,
      update: true,
      requestsLoaded: true,
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          oznAkt: data[1].oznAkt,
          idDrustva: data[1].idDrustva,
          oib: data[1].oib,
          nazDrustva: data[1].nazDrustva,
          regBroj: data[1].regBroj,
          sifPOblika: String(data[1].sifPOblika),
          opisPOblika: data[1].opisPOblika || "",
          oibValidated: true,
          tstampUnosa: data[1].tstampUnosa,
        },
        address,
        officeAddress,
        basicReviserData,
        auditCompanyRegistration,
        auditCompanyRegistrationForeign,
        supervisoryAuthority,
        contactInformation,
        auditCompanyMember,
        auditCompanyBoardMember,
        memberInfo,
        oznDokumenta,
        mjere: data[10],
      },
      networkMemberInfo,
    }));
  };

  getCountryList = async () => {
    try {
      const { data } = await axiosInstance.get("/sifarnici/drzave");
      this.setState(
        {
          countryList: data,
        },
        () => {
          this.getCountyList();
        }
      );
    } catch (e) {
      throw e;
    }
  };

  getCountyList = async () => {
    try {
      const { data } = await axiosInstance.get("/sifarnici/zupanije");
      this.setState(
        {
          countyList: data,
        },
        () => {
          this.getLegalForms();
        }
      );
    } catch (e) {
      throw e;
    }
  };

  getLegalForms = async () => {
    try {
      const { data } = await axiosInstance.get("/sifarnici/pravniOblici");
      const legalForms = data;
      this.setState(
        {
          legalForms,
        },
        () => {
          this.getNetworks();
        }
      );
    } catch (e) {
      throw e;
    }
  };

  checkIfUpdate = (url) => {
    return this.props.match.url.includes(url);
  };

  getNetworks = async () => {
    try {
      const { data } = await axiosInstance.get("/sifarnici/mreze");
      const networksList = data;
      const updatePage = this.props.match.url.includes(
        "/azuriraj/registar-revizorskih-drustava"
      );

      this.setState(
        {
          networksList,
        },
        () => {
          !updatePage && this.disableLoader();
          if (this.checkIfUpdate("/azuriraj/registar-revizorskih-drustava")) {
            if (this.props.idDrustva != this.props.match.params.id) {
              const { purgeUpdate, history } = this.props;
              purgeUpdateAndRedirect(purgeUpdate, () =>
                history.push("/pregled-registara")
              );
              return;
            }
            this.getDrustvoEdit();
          } else if (
            this.checkIfUpdate(
              "/azuriraj-po-zahtjevu/registar-revizorskih-drustava"
            )
          ) {
            if (this.props.idDrustva != this.props.match.params.id) {
              const { purgeUpdate, history } = this.props;
              purgeUpdateAndRedirect(purgeUpdate, () =>
                history.push("/pregled-registara")
              );
              return;
            }

            const oznDokumenta = this.props.oznDokumenta;
            this.getDrustvoEdit(oznDokumenta);
          } else {
            this.getDataFromUnosZahtjeva();
          }
        }
      );
    } catch (e) {
      throw e;
    }
  };

  getDataFromUnosZahtjeva = async () => {
    const { data } = await fetchFormsApi(
      `/request/${this.props.zahtjevAtrId}?isEdit=${false}`
    );

    const findObjectByLabelAndGroup = (label, group) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find(
          (element) =>
            element.controlLabel == label && element.addressGroup === group
        )
      );
      return findLabel;
    };

    const findObjectByLabel = (label) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find((element) => element.controlLabel == label)
      );
      return findLabel;
    };

    // if (data.formId == 3) {
    const findCountry = findObjectByLabelAndGroup("Naziv države", 1);

    const findCity = findObjectByLabelAndGroup("Naziv grada", 1);

    const findDistrict = findObjectByLabelAndGroup("Naziv mjesta", 1);

    const findbrPoste = findObjectByLabelAndGroup("Poštanski broj", 1);

    const findUlica = findObjectByLabelAndGroup("Ulica", 1);

    const findKucniBr = findObjectByLabelAndGroup("Kućni broj", 1);

    let ulicaKbr;

    if (findUlica[0].value || findKucniBr[0].value) {
      ulicaKbr = `${findUlica[0].value} ${findKucniBr[0].value}`;
    } else {
      ulicaKbr = "";
    }

    const brPoste = findbrPoste[0].value || "";

    const findSifPOblika = findObjectByLabel("Pravni oblik");
    let sifPOblika;
    if (findSifPOblika[0].value != "") {
      const res = await axiosInstance.get(
        `/sifarnici/pravniOblici/sifra?nazivPravnogOblika=${findSifPOblika[0].value}`
      );
      if (res.data && res.data.sifPravnogOblika) {
        sifPOblika = String(res.data.sifPravnogOblika);
      } else {
        sifPOblika = "";
      }
    } else {
      sifPOblika = "";
    }

    const findIme = findObjectByLabel("Ime glavne osobe za kontakt");
    const findPrezime = findObjectByLabel("Prezime glavne osobe za kontakt");
    const findTelefon = findObjectByLabel("Telefon");
    const findEmail = findObjectByLabel("E-mail");
    const findWeb = findObjectByLabel("Adresa internetske stranice");
    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let emailValidated;

    if (findEmail[0].value.length > 0) {
      emailValidated = regexp.test(findEmail[0].value);
    } else {
      emailValidated = true;
    }

    const contactInformation = [
      ...this.state.newFormData.contactInformation.map((element) => {
        return element.id == 1
          ? {
            id: 1,
            ime: findIme[0].value || "",
            prezime: findPrezime[0].value || "",
            telefon: findTelefon[0].value || "",
            web: findWeb[0].value || "",
            email: findEmail[0].value || "",
            emailValidated,
          }
          : element;
      }),
    ];

    let sifZupanije;
    let nazZupanije;
    let sifGrdOpc;
    let nazGrdOpc;
    let cityAndMuncipalityList;
    let districtList;
    let nazNaselja;
    let sifNaselja;
    let getDistrictList;

    if (findCountry[0].value == 191 && findCity[0].value != "") {
      const response = await axiosInstance.get(
        `/sifarnici/grad/${findCity[0].value}`
      );
      sifZupanije = response.data.sifZupanije.toString();
      nazZupanije = response.data.nazZupanije;
      sifGrdOpc = findCity[0].value;

      const getCityList = await axiosInstance.get(
        `/sifarnici/gradOpcina/${sifZupanije}`
      );
      cityAndMuncipalityList = getCityList.data;

      getDistrictList = await axiosInstance.get(
        `/sifarnici/naselja/${sifGrdOpc}`
      );
      districtList = getDistrictList.data;
      const findNazivGrada = getCityList.data.filter((element) =>
        element.gradoviOpcine.find((el) => el.sifGrdOpc == sifGrdOpc)
      );

      nazGrdOpc = findNazivGrada[0].gradoviOpcine[0].nazGrdOpc;

      sifNaselja = findDistrict[0].value;

      const findNazivNaselja = getDistrictList.data.filter((element) =>
        element.naselja.find((el) => el.sifNaselja == sifNaselja)
      );

      if (findNazivNaselja.length > 0) {
        nazNaselja = findNazivNaselja[0].naselja[0].nazNaselja;
      } else {
        nazNaselja = findDistrict[0].value;
        sifNaselja = "";
      }
    } else {
      nazZupanije = "";
      sifZupanije = "";
      nazGrdOpc = findCity[0].value;
      cityAndMuncipalityList = [];
      districtList = [];
      nazNaselja = findDistrict[0].value;
      sifGrdOpc = "";
      sifNaselja = "";
      districtList = [];
    }

    const address = {
      ...this.state.newFormData.address,
      sifDrzave: findCountry[0].value,
      sifZupanije,
      nazZupanije,
      sifGrdOpc,
      nazGrdOpc,
      brPoste,
      ulicaKbr,
      nazNaselja,
      sifNaselja,
    };

    //mapiranje za registracije

    const findBrRegDrugeDrzave = findObjectByLabel(
      "Broj registracije kod nadležnog tijela druge države članice"
    );

    const findNazivTijelaDrugeDrzave = findObjectByLabel(
      "Naziv nadležnog tijela iz druge države članice"
    );

    const brRegDrDrzave = findBrRegDrugeDrzave[0]
      ? findBrRegDrugeDrzave[0].value
      : "";

    const nazTijelaDrDrzave = findNazivTijelaDrugeDrzave[0]
      ? findNazivTijelaDrugeDrzave[0].value
      : "";

    const auditCompanyRegistration = [
      {
        vrRegistracije: "2",
        nazTijela: nazTijelaDrDrzave,
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: brRegDrDrzave,
        datReg: "",
        id: 1,
      },
    ];

    const findBrRegTreceZemlje = findObjectByLabel(
      "Broj registracije kod nadležnog tijela u trećoj zemlji"
    );

    const findNazivTijelaTreceZemlje = findObjectByLabel(
      "Naziv nadležnog tijela u trećoj zemlji"
    );

    const brRegTreceZemlje = findBrRegTreceZemlje[0]
      ? findBrRegTreceZemlje[0].value
      : "";

    const nazTijelaTreceZemlje = findNazivTijelaTreceZemlje[0]
      ? findNazivTijelaTreceZemlje[0].value
      : "";

    const auditCompanyRegistrationForeign = [
      {
        vrRegistracije: "3",
        nazTijela: nazTijelaTreceZemlje,
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: brRegTreceZemlje,
        datReg: "",
        id: 1,
      },
    ];

    this.setState((prevState) => ({
      cityAndMuncipalityList,
      districtList,
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          oibValidated: true,
          sifPOblika,
          oib: data.oib || "",
          nazDrustva: data.nazivSubjekta || "",
        },
        address,
        contactInformation,
        auditCompanyRegistration,
        auditCompanyRegistrationForeign,
      },
    }));
    this.disableLoader();
  };

  disableLoader = () => {
    this.setState({
      requestsLoaded: true,
    });
  };

  getCityAndMuncipalityList = async (countyId) => {
    const { data } = await axiosInstance.get(
      `/sifarnici/gradOpcina/${countyId}`
    );
    this.setState({
      cityAndMuncipalityList: data,
    });
  };

  getDistrictList = async (id) => {
    const { data } = await axiosInstance.get(`/sifarnici/naselja/${id}`);
    this.setState({ districtList: data });
  };

  userInputHandler = (e, objectData) => {
    e.persist();
    const { name } = e.target;
    // const { id } = e.target;
    this.setState(handleUserInput(e, objectData), () => {
      name === "oib" &&
        this.state.newFormData.userData.oibValidated &&
        this.fetchUserDataCoib();
    });
  };

  fetchUserDataCoib = async () => {
    const oib = this.state.newFormData.userData.oib;
    const { data } = await axiosInstance.get(`/sifarnici/oib-data/${oib}`);

    //ovo smece treba testirati
    const sifGradOpcina = data.sifraGradaOpcine.replace(/^0+/, "");
    const sifraNaselja = data.sifraNaselja.replace(/^0+/, "");

    this.getCityAndMuncipalityList(data.sifraZupanije);
    this.getDistrictList(sifGradOpcina);

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          nazDrustva: data.nazivSkraceni,
        },
        address: {
          ...prevState.newFormData.address,
          sifDrzave: data.sifraDrzave,
          sifZupanije: data.sifraZupanije,
          nazZupanije: data.nazivZupanije,
          sifGrdOpc: sifGradOpcina,
          nazGrdOpc: data.grad,
          sifNaselja: sifraNaselja,
          nazNaselja: data.naselje,
          brPoste: data.postanskiBroj,
          ulicaKbr: `${data.adresa} ${data.kucniBroj} ${data.kucniBrojDodatak}`,
        },
      },
    }));
  };

  validateEmail = (e, objectData) => {
    const value = e.target.value;
    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailValidated = regexp.test(value);
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objectData.group]: [
          ...prevState.newFormData[objectData.group].map((element) =>
            element.id === objectData.id
              ? {
                ...element,
                emailValidated,
              }
              : element
          ),
        ],
      },
    }));
  };

  openNetworkUpdateModal = () => {
    const { networkMemberInfo } = this.state;

    const findNetworkObjById = this.state.networksList.find(
      (element) => element.idMreze == networkMemberInfo.idMreze
    );

    this.setState((prevState) => ({
      showUpdateModal: true,
      newFormData: {
        ...prevState.newFormData,
        networkUpdateObj: {
          ...findNetworkObjById,
          requiredFieldsNetworkUpdate: [
            "nazMreze",
            "nazNaselja",
            "brPoste",
            "ulicaKbr",
          ],
        },
      },
    }));
  };

  hideUpdateModal = () => {
    this.setState((prevState) => ({
      showUpdateModal: false,
      newFormData: {
        ...prevState.newFormData,
        networkUpdateObj: {
          nazMreze: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          requiredFieldsNetworkUpdate: [
            "nazMreze",
            "nazNaselja",
            "brPoste",
            "ulicaKbr",
          ],
        },
      },
    }));
  };

  updateNetworkHandler = async () => {
    const stateCopy = { ...this.state.newFormData };

    const { requiredFieldsNetworkUpdate } = stateCopy.networkUpdateObj;

    const validateNetworkSubmit = validateRequiredFields(
      stateCopy.networkUpdateObj,
      requiredFieldsNetworkUpdate
    );

    if (!validateNetworkSubmit) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    this.setState({ loader: true }, async () => {
      try {
        let submitData = { ...stateCopy.networkUpdateObj };
        delete submitData.requiredFieldsNetworkUpdate;
        const res = await axiosInstance.patch(
          `/sifarnici/mreza/edit/${stateCopy.networkUpdateObj.idMreze}`,
          submitData
        );
        this.setState(
          (prevState) => ({
            loader: false,
            showUpdateModal: false,
          }),
          async () => {
            this.props.formSubmitSuccess(false, "Mreža je uspješno ažurirana!");
            const { data } = await axiosInstance.get("/sifarnici/mreze");
            const networksList = data;

            this.setState({
              networksList,
              networkMemberInfo: {
                isDrustvoMreza: true,
                idMreze: "",
              },
            });
          }
        );
      } catch (e) {
        throw e;
        this.props.formSubmitSuccess(
          true,
          "Nešto je pošlo po krivu s ažuriranjem mreže!"
        );
        this.setState({
          loader: false,
        });
      }
    });
  };

  mappedUserInputHandler = (e, objectData) => {
    e.persist();
    const isEmail = e.target.name === "email";
    const ovlRevOib =
      e.target.name === "oib" && objectData.group == "basicReviserData";

    this.setState(handleMappedUserInput(e, objectData), () => {
      //validiraj email ako je polje email
      isEmail && this.validateEmail(e, objectData);
      ovlRevOib && this.clearReviserData(objectData.id);
    });
  };

  funkcijaDropDownHandler = (e) => {
    e.persist()
    const id = e.target.id.replace(/[^0-9]/g, ""); 
    let funk;
      switch (Number(e.target.value)) {
        case 3:
          funk= "Direktor";
          break;
        case 4: 
          funk= "Predsjednik uprave";
          break;
        case 5:
          funk="Član uprave";
          break;
        case 6:
          funk="Prokurist";
          break;
        case 7:
          funk="Član upravnog odbora";
          break;
        default:
          break;
      }
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        auditCompanyBoardMember: [
          ...prevState.newFormData.auditCompanyBoardMember.map((element) => {
            return element.id == id
              ? {
                ...element,
                funkcija: funk,
              }
              : element;
          }),
        ],
      },
    }));
  }

  clearReviserData = (id) => {
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        basicReviserData: [
          ...prevState.newFormData.basicReviserData.map((element) => {
            return element.id == id
              ? {
                ...element,
                prezime: "",
                ime: "",
                regBroj: "",
                idOsobe: "",
                id: element.id,
              }
              : element;
          }),
        ],
      },
    }));
  };

  setCountryAutocompleteHandler = (values, objectData) => {
    this.setState(handleCountryAutocomplete(values, objectData));
  };

  autocompleteCountryHandler = (values, objectData) => {
    this.setState(countryAutocompleteHandler(values, objectData));
  };

  autocompleteCountyHandler = (values, objectData) => {
    this.setState(
      countyAutocompleteHandler(
        values,
        objectData,
        this.getCityAndMuncipalityList
      )
    );
  };

  autocompleteCityHandler = (values, objectData) => {
    this.setState(
      cityAndMuncipalityAutocomplete(values, objectData, this.getDistrictList)
    );
  };

  autocompleteDistrictHandler = (values, objectData) => {
    const stateCopy = this.state;

    this.setState(districtAutocompleteHandler(values, objectData), () => {
      if (
        stateCopy.newFormData[objectData.formGroup].hasOwnProperty("brPoste") &&
        values != null
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.formGroup]: {
              ...prevState.newFormData[objectData.formGroup],
              brPoste: String(values.brPoste),
            },
          },
        }));
      }
    });
  };

  networkDropdownHandler = (e) => {
    e.persist();

    const memberInfo = (element) => {
      return element.vrClana == 1
        ? {
          ...element,
          vrClana: "",
          idMreze: "",
          idDrustva: "",
          nazDrustva: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
          oibValidated: false,
        }
        : element;
    };

    const isDrustvoMreza = e.target.value;
    this.setState((prevState) => ({
      networkMemberInfo: {
        ...prevState.networkMemberInfo,
        isDrustvoMreza,
        idMreze: "",
      },
      newFormData: {
        ...prevState.newFormData,
        memberInfo: [...prevState.newFormData.memberInfo.map(memberInfo)],
      },
    }));
  };

  dropdownHandler = (e) => {
    e.persist();
    const sifPOblika = e.target.value;
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          sifPOblika,
          opisPOblika: "",
        },
      },
    }));
  };

  handleDayClick = (date, dateString, objData) => {
    this.setState(handleDayPicker(dateString, objData));
  };
  getReviserDataByOib = async (e) => {
    e.persist();
    const id = e.currentTarget.id;

    const stateCopy = { ...this.state.newFormData };
    const findReviserObject = stateCopy.basicReviserData.find(
      (element) => element.id == id
    );

    try {
      const { data } = await axiosInstance.get(
        `/sifarnici/osobe?oib=${findReviserObject.oib}`
      );

      if (data.length === 0) {
        this.props.formSubmitError(
          true,
          "Za OIB/identifikator koji ste unijeli nema dostupnih podataka o ovlaštenom revizoru! Unesite ispravan OIB/identifikator."
        );
        return;
      }

      //ovo je hardkodirano, potrebno vidjeti s bekendom u vezi ovoga
      let reviserObject = { ...findReviserObject };
      reviserObject.ime = data[0].ime;
      reviserObject.prezime = data[0].prezime;
      reviserObject.regBroj = data[0].regBroj;
      reviserObject.idOsobe = data[0].idOsobe;
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          basicReviserData: [
            ...prevState.newFormData.basicReviserData.map((element) => {
              return element.id == id ? reviserObject : element;
            }),
          ],
        },
      }));
    } catch (e) {
      throw e;
    }
  };

  createNewNetworkModal = () => {
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        createNewNetworkModal: !prevState.newFormData.createNewNetworkModal,
        createNewNetworkData: {
          nazMreze: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          requiredFieldsCreateNewNetwork: [
            "nazMreze",
            "sifDrzave",
            "nazNaselja",
            "brPoste",
            "ulicaKbr",
          ],
        },
      },
    }));
  };

  multiplyComponent = (e, objData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objData.formGroup]];

    let addNewElement;

    switch (objData.formGroup) {
      case "contactInformation":
        addNewElement = {
          ime: "",
          prezime: "",
          telefon: "",
          web: "",
          email: "",
          emailValidated: false,
          id: lastElem[lastElem.length - 1].id + 1,
        };
        break;
      case "officeAddress":
        addNewElement = {
          vrAdr: "2",
          ulicaKbr: "",
          nazNaselja: "",
          brPoste: "",
          sifDrzave: "191",
          id: lastElem[lastElem.length - 1].id + 1,
        };
        break;
      case "basicReviserData":
        addNewElement = {
          oib: "",
          prezime: "",
          ime: "",
          regBroj: "",
          idOsobe: "",
          id: lastElem[lastElem.length - 1].id + 1,
          requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: false,
        };
        break;
      case "auditCompanyRegistration":
        addNewElement = {
          vrRegistracije: "2",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          id: lastElem[lastElem.length - 1].id + 1,
        };
        break;
      case "auditCompanyRegistrationForeign":
        addNewElement = {
          vrRegistracije: "3",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          id: lastElem[lastElem.length - 1].id + 1,
        };
        break;
      case "auditCompanyMember":
        addNewElement = {
          vrClana: "1",
          oib: "",
          ime: "",
          prezime: "",
          naziv: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: lastElem[lastElem.length - 1].id + 1,
          oibValidated: false,
          requiredFieldsAuditCompanyMember: [
            "oib",
            // "ime",
            // "prezime",
            // "naziv",
            "sifDrzave",
            // "nazNaselja",
            // "brPoste",
            // "ulicaKbr"
          ],
        };
        break;
      case "auditCompanyBoardMember":
        addNewElement = {
          vrClana: "2",
          oib: "",
          ime: "",
          prezime: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          funkcija: "",
          ulicaKbr: "",
          id: lastElem[lastElem.length - 1].id + 1,
          oibValidated: false,
          requiredFieldsAuditCompanyBoardMember: [
            "ime",
            "prezime",
            "funkcija",
            "sifDrzave",
            // "nazNaselja",
            // "brPoste",
            // "ulicaKbr"
          ],
        };
        break;
      case "supervisoryAuthority":
        addNewElement = {
          vrRegistracije: "4",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: lastElem[lastElem.length - 1].id + 1,
        };
        break;
      case "memberInfo":
        addNewElement = {
          vrClana: "",
          // memberType: "",
          id: lastElem[lastElem.length - 1].id + 1,
          idMreze: "",
          idDrustva: "",
          nazDrustva: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
          oibValidated: false,
        };
        break;
      default:
        break;
    }
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objData.formGroup]: [
          ...prevState.newFormData[objData.formGroup],
          addNewElement,
        ],
      },
    }));
  };

  setSelectedNetworkDropdown = async (e) => {
    const idMreze = e.target.value;
    this.setState((prevState) => ({
      networkMemberInfo: {
        ...prevState.networkMemberInfo,
        idMreze,
      },
    }));
  };

  setSelectedNetworkToArray = async (e) => {
    e.persist();
    const idMreze = e.target.value;
    const id = e.target.id.replace(/[^0-9]/g, "");

    let findObject = {
      ...this.state.newFormData.memberInfo.find((element) => element.id == id),
    };

    findObject.idMreze = e.target.value;
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        memberInfo: [
          ...prevState.newFormData.memberInfo.map((element) => {
            return element.id == id ? findObject : element;
          }),
        ],
      },
    }));
  };

  vrClanaDropdownHandler = (selectedValue, id) => {
    if (selectedValue == null) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          memberInfo: [
            ...prevState.newFormData.memberInfo.map((element) =>
              element.id == id
                ? {
                  vrClana: "",
                  id: element.id,
                  idMreze: "",
                  idDrustva: "",
                  nazDrustva: "",
                  sifDrzave: "191",
                  nazNaselja: "",
                  brPoste: "",
                  ulicaKbr: "",
                  web: "",
                }
                : element
            ),
          ],
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        memberInfo: [
          ...prevState.newFormData.memberInfo.map((element) =>
            element.id == id
              ? {
                vrClana: selectedValue.id,
                id: element.id,
                idMreze: "",
                idDrustva: "",
                nazDrustva: "",
                sifDrzave: "191",
                nazNaselja: "",
                brPoste: "",
                ulicaKbr: "",
                web: "",
              }
              : element
          ),
        ],
      },
    }));

    // const id = e.target.id;
    // const value = e.target.value;
    // e.persist();
    // this.setState((prevState) => ({
    //   newFormData: {
    //     ...prevState.newFormData,
    //     memberInfo: [
    //       ...prevState.newFormData.memberInfo.map((element) =>
    //         element.id == id
    //           ? {
    //               vrClana: value,
    //               // memberType: "",
    //               id: element.id,
    //               idMreze: "",
    //               idDrustva: "",
    //               nazDrustva: "",
    //               sifDrzave: "191",
    //               nazNaselja: "",
    //               brPoste: "",
    //               ulicaKbr: "",
    //               web: "",
    //             }
    //           : element
    //       ),
    //     ],
    //   },
    // }));
  };

  createNewNetworkSubmitHandler = async () => {
    const stateCopy = { ...this.state.newFormData };

    const { requiredFieldsCreateNewNetwork } = stateCopy.createNewNetworkData;

    const validateNetworkSubmit = validateRequiredFields(
      stateCopy.createNewNetworkData,
      requiredFieldsCreateNewNetwork
    );

    if (!validateNetworkSubmit) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    this.setState({ loader: true }, async () => {
      try {
        let submitData = { ...stateCopy.createNewNetworkData };
        delete submitData.requiredFieldsCreateNewNetwork;
        const res = await axiosInstance.post("/sifarnici/mreza", submitData);
        this.setState(
          (prevState) => ({
            newFormData: {
              ...prevState.newFormData,
              createNewNetworkModal: false,
              loader: false,
            },
          }),
          async () => {
            this.props.formSubmitSuccess(
              false,
              "Nova mreža je uspješno kreirana!"
            );
            const { data } = await axiosInstance.get("/sifarnici/mreze");
            const networksList = data;
            this.setState({
              networksList,
              loader: false,
            });
          }
        );
      } catch (e) {
        throw e;
        this.props.formSubmitSuccess(
          true,
          "Nešto je pošlo po krivu s kreiranjem mreže!"
        );
        this.setState({
          loader: false,
        });
      }
    });
  };

  removeComponentHandler = (e, objectData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objectData.formGroup]];
    const { formGroup } = objectData;
    const arrayLength = this.state.newFormData[formGroup].length;
    const id = e.currentTarget.id.replace(/[^0-9]/g, "");

    if (arrayLength > 1) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          [formGroup]: [
            ...prevState.newFormData[formGroup].filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
    } else {
      alert("Uklanjanje nije moguće!");
    }
  };

  submitHandler = async (e) => {
    e.preventDefault();

    const { zahtjevAtrId } = this.props;
    const stateCopy = { ...this.state.newFormData };
    const { requiredFieldsUserData } = stateCopy.userData;
    const validateUserData = validateRequiredFields(
      stateCopy.userData,
      requiredFieldsUserData
    );
    let { requiredFieldsAddress } = stateCopy.address;
    if (stateCopy.address.sifDrzave != "191") {
      requiredFieldsAddress = [
        "sifDrzave",
        "nazNaselja",
        "ulicaKbr",
        "permitDate",
        "permitNumber",
      ];
    }
    const validateAddress = validateRequiredFields(
      stateCopy.address,
      requiredFieldsAddress
    );

    const validateBasicReviserData = validateArrayFields(
      stateCopy.basicReviserData,
      "requiredFieldsRevData"
    ).every((element) => element === true);

    const validateAuditCompanyMember = validateArrayFields(
      stateCopy.auditCompanyMember,
      "requiredFieldsAuditCompanyMember"
    ).every((element) => element === true);

    const validateAuditCompanyBoardMember = validateArrayFields(
      stateCopy.auditCompanyBoardMember,
      "requiredFieldsAuditCompanyBoardMember"
    ).every((element) => element === true);

    const validateNetwork =
      this.state.networkMemberInfo.isDrustvoMreza === false;
    //ovo
    // const validateMemberInfo = validateArrayFields(
    //   stateCopy.memberInfo,
    //   "requiredFieldsMemberInfo"
    // ).every(element => element === true);

    if (
      !validateUserData ||
      !validateAddress ||
      !validateBasicReviserData ||
      !validateAuditCompanyBoardMember ||
      !validateAuditCompanyMember ||
      validateNetwork
      //  ||
      // !validateMemberInfo
    ) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    if (!stateCopy.userData.oibValidated) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Osnovni podaci)"
      );
      return;
    }

    if (
      stateCopy.userData.sifPOblika == "999" &&
      stateCopy.userData.opisPOblika.length < 1
    ) {
      return this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Unesite opis pravnog oblika!");
        }
      );
    }

    const validateAuditCompanyMemberOib = [
      ...stateCopy.auditCompanyMember,
    ].every((element) => element.oibValidated === true);

    if (!validateAuditCompanyMemberOib) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Član/dioničar revizorskog društva)"
      );
      return;
    }

    const validateAuditCompanyBoardMemberOib = [
      ...stateCopy.auditCompanyBoardMember,
    ]
      .filter((element) => element.oib.length > 0)
      .every((element) => element.oibValidated === true);

    if (!validateAuditCompanyBoardMemberOib) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Član uprave ili upravnog odbora revizorskog društva)"
      );
      return;
    }

    const networkNotSelected = [...stateCopy.memberInfo]
      .filter((element) => element.vrClana === "1")
      .every((element) => element.idMreze);

    if (!networkNotSelected) {
      this.props.formSubmitError(true, "Odaberite pripadnost mreži!");
      return;
    }

    const emptyNazDrustva = [...stateCopy.memberInfo]
      .filter((element) => element.vrClana == 2)
      .every((element) => element.nazDrustva.length > 0);

    if (!emptyNazDrustva) {
      return this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Unesite naziv društva!");
        }
      );
    }

    //ako je korisnik odabrao pripadnost mrezi/drustvu, provjeri jesu li svi fieldovi popunjeni (adresa ili web)
    const networkAddressNotFilled = [...stateCopy.memberInfo]
      .filter((element) => element.vrClana != "")
      .every(
        (element) =>
          (element.nazNaselja && element.brPoste && element.ulicaKbr) ||
          // &&
          // element.brPoste
          element.web
      );

    //ovo treba dobro testirati, upozoriti testere!
    if (!networkAddressNotFilled) {
      return this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(
            true,
            "Popunite adresu ili web adresu za provjeru podataka!"
          );
        }
      );
    }

    const isEmailValidated = [...stateCopy.contactInformation].filter(
      (element) => !element.emailValidated && element.email.length > 0
    );

    if (isEmailValidated.length > 0) {
      this.setState({ error: true }, () => {
        this.props.formSubmitError(
          true,
          "E-mail koji ste upisali nije ispravan!"
        );
      });
      return;
    }

    // podaci o korisniku ??
    const userData = { ...stateCopy.userData };
    delete userData.oibValidated;
    delete userData.requiredFieldsUserData;
    delete userData.oznAkt;
    //adresa 1
    const address = { ...stateCopy.address };
    //adresa 2
    const officeAddress = [...stateCopy.officeAddress].map((element) => {
      return {
        vrAdr: element.vrAdr,
        ulicaKbr: element.ulicaKbr,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        sifDrzave: element.sifDrzave,
      };
    });

    //reg1
    const regAddress = {
      vrRegistracije: "1",
      sifDrzave: address.sifDrzave,
      brReg: address.permitNumber,
      datReg: address.permitDate,
    };

    delete address.permitDate;
    delete address.permitNumber;
    delete address.requiredFieldsAddress;

    //reg2
    const auditCompanyRegistration = [
      ...stateCopy.auditCompanyRegistration,
    ].map((element, index) => {
      return {
        vrRegistracije: "2",
        nazTijela: element.nazTijela,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
        brReg: element.brReg,
        datReg: element.datReg,
      };
      // delete element.id;
      // delete element.requiredFieldsAuditCompanyRegistration;
      // return element;
    });
    //reg3
    const auditCompanyRegistrationForeign = [
      ...stateCopy.auditCompanyRegistrationForeign,
    ].map((element, index) => {
      return {
        vrRegistracije: "3",
        nazTijela: element.nazTijela,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
        brReg: element.brReg,
        datReg: element.datReg,
      };
      // delete element.id;
      // delete element.requiredFieldsAuditCompanyRegistration;
      // return element;
    });

    //reg4
    const supervisoryAuthority = [...stateCopy.supervisoryAuthority].map(
      (element) => {
        return {
          vrRegistracije: "4",
          nazTijela: element.nazTijela,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
        };
      }
    );

    //podaci o korisniku

    const contactInformation = [...stateCopy.contactInformation].map(
      (element) => {
        return {
          ime: element.ime,
          prezime: element.prezime,
          telefon: element.telefon,
          web: element.web,
          email: element.email,
        };
      }
    );

    //veza => ovlašteni revizor
    const basicReviserData = [...stateCopy.basicReviserData].map((element) => {
      return {
        vrVeze: "1",
        idOsobe: String(element.idOsobe),
      };
    });

    //članovi

    // član 1
    const auditCompanyMember = [...stateCopy.auditCompanyMember].map(
      (element) => {
        return {
          vrClana: "1",
          funkcija:"Dioničar/član društva",
          oib: element.oib,
          ime: element.ime,
          prezime: element.prezime,
          naziv: element.naziv,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
        };
      }
    );
    //član 2
    const auditCompanyBoardMember = [...stateCopy.auditCompanyBoardMember].map(
      (element) => {
        return {
          vrClana: "2",
          oib: element.oib,
          ime: element.ime,
          prezime: element.prezime,
          funkcija: element.funkcija,
          naziv: element.naziv,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
        };
      }
    );

    // društvo mreža
    let mrezaInfo = { ...this.state.networkMemberInfo };
    //ovo
    // if (mrezaInfo.isDrustvoMreza === false) {
    //   this.props.formSubmitError(true, "Odaberite članstvo u mreži !");
    //   return;
    // }

    if (mrezaInfo.isDrustvoMreza == 0 || mrezaInfo.isDrustvoMreza === false) {
      delete mrezaInfo.idMreze;
      mrezaInfo.isDrustvoMreza = false;
    } else {
      mrezaInfo.isDrustvoMreza = true;
    }

    const checkMreza = mrezaInfo.hasOwnProperty("idMreze");
    if (checkMreza && !mrezaInfo.idMreze) {
      this.props.formSubmitError(true, "Odaberite mrežu !");
      return;
    }

    // članovi mreže
    const memberInfo = [...stateCopy.memberInfo].map((element) => {
      if (element.vrClana == 1) {
        return {
          idMreze: element.idMreze,
          vrClana: element.vrClana,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          web: element.web,
        };
      } else if (element.vrClana == 2) {
        return {
          vrClana: element.vrClana,
          nazDrustva: element.nazDrustva,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          web: element.web,
        };
      }
      return {
        vrClana: "",
        idMreze: "",
        nazDrustva: "",
        sifDrzave: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        web: "",
      };
    });

    //oznaka dokumenta => hardkodirano => vidjeti s bekendom sto dalje

    const { oznDokumenta } = this.state.newFormData;

    const addressArray = [];

    addressArray.push(address, ...officeAddress);

    const registrationArray = [];

    registrationArray.push(
      regAddress,
      ...auditCompanyRegistration,
      ...auditCompanyRegistrationForeign,
      ...supervisoryAuthority
    );

    const membersArray = [];

    membersArray.push(...auditCompanyMember, ...auditCompanyBoardMember);

    const submitData = [
      2,
      userData,
      addressArray,
      registrationArray,
      contactInformation,
      basicReviserData,
      membersArray,
      mrezaInfo,
      memberInfo,
      oznDokumenta,
    ];

    try {
      this.setState({
        loader: true,
      });
      if (!this.state.update) {
        submitData.push([]);
        const res = await axiosInstance
          .post(`/unos/${zahtjevAtrId}`, submitData)
          .then(() =>
            this.setState({
              loader: false,
            })
          );
        this.props.formSubmitSuccess(
          false,
          "Podaci o subjektu uspješno upisani."
        );
        this.props.history.push("/odobrenje-zahtjeva");
        return;
      }
      submitData.push(stateCopy.mjere);
      const res = await axiosInstance.patch("/edit", submitData).then(() =>
        this.setState({
          loader: false,
        })
      );
      this.props.formSubmitSuccess(false, "Podaci uspješno ažurirani.");
      this.props.history.goBack();
    } catch (e) {
      this.props.formSubmitError(
        true,
        e.response.data.message ||
        "Nešto je pošlo po krivu, provjerite unesene podatke!"
      );
      this.setState({
        loader: false,
      });
    }
  };

  render() {
    const otherProps = {
      parentState: this.state,
      handleDayClick: this.handleDayClick,
      userInputHandler: this.userInputHandler,
      mappedUserInputHandler: this.mappedUserInputHandler,
      setCountryAutocompleteHandler: this.setCountryAutocompleteHandler,
      autocompleteCountryHandler: this.autocompleteCountryHandler,
      autocompleteCountyHandler: this.autocompleteCountyHandler,
      autocompleteCityHandler: this.autocompleteCityHandler,
      autocompleteDistrictHandler: this.autocompleteDistrictHandler,
      dropdownHandler: this.dropdownHandler,
      submitHandler: this.submitHandler,
      multiplyComponent: this.multiplyComponent,
      networkDropdownHandler: this.networkDropdownHandler,
      setSelectedNetworkDropdown: this.setSelectedNetworkDropdown,
      createNewNetworkModal: this.createNewNetworkModal,
      createNewNetworkSubmitHandler: this.createNewNetworkSubmitHandler,
      vrClanaDropdownHandler: this.vrClanaDropdownHandler,
      setSelectedNetworkToArray: this.setSelectedNetworkToArray,
      getUserData: this.getUserData,
      getReviserDataByOib: this.getReviserDataByOib,
      removeComponentHandler: this.removeComponentHandler,
      openNetworkUpdateModal: this.openNetworkUpdateModal,
      hideUpdateModal: this.hideUpdateModal,
      updateNetworkHandler: this.updateNetworkHandler,
      funkcijaDropDownHandler: this.funkcijaDropDownHandler,
    };

    return (
      <>
        {this.state.requestsLoaded ? (
          <EntryForm1 {...otherProps} />
        ) : (
          <Spinner />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    idDrustva: state.update.idDrustva,
    vrDrustva: state.update.vrDrustva,
    oznDokumenta: state.update.oznDokumenta,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
    purgeUpdate: () => dispatch({ type: PURGE_UPDATE }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistarRevizorskihDrustava);
